export default __webpack_public_path__ + "static/media/DollarImage.0961cb02.svg";